import React from 'react';
import { useTranslation } from "react-i18next";
import { FaPhone } from "react-icons/fa6";
import { MdOutlineEmail } from "react-icons/md";

const FooterMenusData = () => {
    const { t } = useTranslation();

    return [
        {
            title: t('Useful Links'),
            lists: [
                { icon: '', text: t('Home'), link: '/' },
                { icon: '', text: t('About Us'), link: '/about' },
                { icon: '', text: t('Jobs'), link: '/alljobs' },
                { icon: '', text: t('Contact'), link: '/contact' }
            ]
        },
        {
            title: t('Contact Us'),
            text: t('Lorem ipsum dolor sit amet, adipiscing elit, euis'),
            lists: [
                { icon: <FaPhone />, text: "+42 355678990" },
                { icon: <MdOutlineEmail />, text: 'example@education.com' }
            ]
        }
    ];
};

export default FooterMenusData;
